import { createContext } from 'react';

export type LearnerEventDetailsContextType = {
  onRegister: (sessionId: string) => void;
  onUnregister: (sessionId: string) => void;
  onRegisterSeries: () => void;
  onUnregisterSeries: () => void;
  onJoinWaitlist: (sessionId: string) => void;
  onLeaveWaitlist: (sessionId: string) => void;
  onJoinWaitlistSeries: () => void;
  onLeaveWaitlistSeries: () => void;
  onMarkAttendance: (sessionId: string) => void;
  onUnmarkAttendance: (sessionId: string) => void;
};

export const LearnerEventDetailsContext = createContext<LearnerEventDetailsContextType | null>(null);
